import api from './api.js'
import drafts from './drafts.js'
import profileConfig from './profileConfig.js'

export default {
  api,
  profileConfig,
  drafts,
}
